import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=db780710&scoped=true"
import script from "./Common.vue?vue&type=script&lang=js"
export * from "./Common.vue?vue&type=script&lang=js"
import style0 from "./Common.vue?vue&type=style&index=0&id=db780710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db780710",
  null
  
)

export default component.exports